export default __webpack_public_path__ + "static/na-d1afa95b2bef9cd78555e3cc277a9500.svg";